import React from 'react';
import { Typography, Button } from '@material-tailwind/react';

export const NoOrderFound = ({ onRetry, onAskQuestion }) => (
    <div className="flex flex-col gap-4 p-4 bg-white rounded-lg shadow-sm m-2">
        <div className="flex items-center gap-4 mb-2">
            <Typography variant="h6" >
                Geen zending gevonden
            </Typography>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-red-500">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
            </svg>
        </div>

        <Typography variant="small" className="text-gray-600 mb-4">
            We konden geen zending vinden met deze gegevens. Wat wil je doen?
        </Typography>

        <div className="flex flex-col gap-2">
            <Button
                onClick={onRetry}
                className="w-full bg-black text-white capitalize px-4 py-2 rounded-lg"
            >
                Opnieuw proberen
            </Button>

            <Button
                onClick={onAskQuestion}
                variant="outlined"
                className="w-full border-2 border-black text-black capitalize px-4 py-2 rounded-lg"
            >
                Stel een vraag
            </Button>
        </div>
    </div>
);